import React from 'react';
/**
 * Used to provide global configuration for form engine like api keys, value providers for dropdowns etc.
 * Alternatively most of the props can be passed directly to the Component that requires it.
 */
export const FormConfigContext = React.createContext({});
